/* eslint-disable jsx-a11y/no-access-key */
import React from "react"
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core/styles'
import { Close } from "@material-ui/icons"
import config from "../../../config"
import { useSelector } from "react-redux"

export default function AiHead({ handleDiscardText }) {
  const { t } = useTranslation();
  const { theme: { colors, bgColors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT

  return (
    <div className='d-flex justify-content-end'>
      <div style={{ color: colors.colorIntermediateText, cursor: "pointer" }} className={`d-flex text-muted`} onClick={handleDiscardText} tabIndex={config.tabIndexes.aiDiscardButton} accessKey={config.accessKeys.aiDiscardButton}>
        <div style={{ width: '22px', height: '22px', borderRadius: '50%', backgroundColor: bgColors.bgPrimary300, display: 'flex', alignItems: 'center', justifyContent: 'center', color: colors.colorContrast, marginRight: 5 }}>
          <Close style={{ fontSize: '1rem' }} />
        </div>
              <p className={`m-0 pl-1`} style={{ fontSize: 13, fontWeight: 'bold', color: isContrast ? colors.colorText : colors.colorIntermediateText }} >
                {t('ai_reject_text_tt')}
              </p>
      </div>
    </div>
  )
}